// BMP-HOOK-START:size-dead-tap
// Main Add to Cart "Please select a size" dead state.
//
// Size is never pre-selected (size-required gate). If the shopper picks a
// colour that has no variant in the hidden default size (e.g. no XS), Horizon
// resolves a non-existent variant and DISABLES the main button. A disabled
// button gets no click at all, so assets/bmp-size-required.js never sees the
// tap and nothing happens.
//
// Fix, without touching core JS or the gate:
//  - CSS (snippets/bmp-globals.liquid#size-dead-tap) gives that disabled button
//    pointer-events:none while the gate is shut, so the tap lands on its
//    wrapper inside the product form.
//  - This listener catches that tap (only when it falls inside the disabled
//    button's box), marks the form data-bmp-size-missing (same state the gate
//    sets, so the gate's own prompt styling applies), announces the prompt,
//    scrolls the Size picker into view below the sticky header, highlights it
//    and focuses the first size. Nothing is added to the cart.
//  - When the gate itself refuses a tap on an ENABLED button, it already
//    scrolls; the observer below adds the same highlight so both paths match.
// Once a size is chosen the gate opens, the CSS no longer applies, and the
// button behaves exactly as before.
(() => {
  if (window.__bmpSizeDeadTap) return;
  window.__bmpSizeDeadTap = true;

  const FORM = 'product-form-component[data-bmp-size-required]';
  const BUTTON = '[ref="addToCartButton"]';
  const HL = 'bmp-size-attention';

  const shut = (form) => form.getAttribute('data-bmp-size-satisfied') !== 'true';
  const visible = (el) => {
    if (!(el instanceof HTMLElement)) return null;
    const r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 ? el : null;
  };

  function sizeTarget(form) {
    const scope = form.closest('dialog, .shopify-section') || document;
    for (const el of scope.querySelectorAll('[data-bmp-size-fieldset], [data-bmp-size-control]')) {
      if (visible(el)) return el;
    }
    return null;
  }

  function headerOffset() {
    let max = 0;
    for (const el of document.elementsFromPoint(window.innerWidth / 2, 4)) {
      for (let n = el; n && n !== document.body; n = n.parentElement) {
        const pos = getComputedStyle(n).position;
        if (pos === 'sticky' || pos === 'fixed') {
          if (n.classList.contains('bmp-sticky-atc')) break;
          max = Math.max(max, n.getBoundingClientRect().bottom);
          break;
        }
      }
    }
    return Math.min(Math.max(max, 0), 200);
  }

  function scrollParent(el) {
    for (let n = el.parentElement; n && n !== document.body && n !== document.documentElement; n = n.parentElement) {
      const oy = getComputedStyle(n).overflowY;
      if ((oy === 'auto' || oy === 'scroll' || oy === 'overlay') && n.scrollHeight > n.clientHeight + 1) return n;
    }
    return window;
  }

  function inView(el) {
    const r = el.getBoundingClientRect();
    return r.top >= headerOffset() - 2 && r.bottom <= window.innerHeight;
  }

  function highlight(target) {
    target.classList.remove(HL);
    void target.offsetWidth;
    target.classList.add(HL);
    clearTimeout(target.__bmpHlT);
    target.__bmpHlT = setTimeout(() => target.classList.remove(HL), 2400);
  }

  function reveal(form) {
    const target = sizeTarget(form);
    if (!target) return;
    const scroller = scrollParent(target);
    const delta = () => target.getBoundingClientRect().top - headerOffset() - 24;
    if (!inView(target)) scroller.scrollBy({ top: delta(), behavior: 'smooth' });
    setTimeout(() => { if (!inView(target) && target.getBoundingClientRect().top < headerOffset()) scroller.scrollBy({ top: delta(), behavior: 'auto' }); }, 700);
    highlight(target);
    const first = target.querySelector('input[type="radio"]:not([disabled]):not([aria-disabled="true"]), select');
    if (first instanceof HTMLElement) setTimeout(() => first.focus({ preventScroll: true }), 750);
  }

  function prompt(form) {
    try {
      return JSON.parse(getComputedStyle(form).getPropertyValue('--bmp-size-required-prompt').trim());
    } catch {
      return '';
    }
  }

  function refuse(form) {
    if (form.getAttribute('data-bmp-size-missing') === 'true') {
      form.removeAttribute('data-bmp-size-missing');
      void form.offsetWidth;
    }
    form.setAttribute('data-bmp-size-missing', 'true');
    const live = form.querySelector('[ref="liveRegion"]');
    const text = prompt(form);
    if (live instanceof HTMLElement && text) { live.textContent = ''; live.textContent = text; }
    reveal(form);
  }

  // Taps that pass THROUGH the disabled button (pointer-events:none) land on
  // its wrapper. Only act when the point is inside the button's own box.
  window.addEventListener('click', (event) => {
    const t = event.target instanceof Element ? event.target : null;
    const form = t && t.closest(FORM);
    if (!form || !shut(form)) return;
    const btn = form.querySelector(BUTTON);
    if (!(btn instanceof HTMLButtonElement) || !btn.disabled || btn.contains(t)) return;
    const r = btn.getBoundingClientRect();
    if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) return;
    event.preventDefault();
    refuse(form);
  }, { capture: true });

  // Gate refused an enabled button (it scrolls itself): add the same highlight.
  new MutationObserver((records) => {
    for (const r of records) {
      const el = /** @type {Element} */ (r.target);
      if (el.getAttribute('data-bmp-size-missing') === 'true' && el.matches(FORM)) {
        const target = sizeTarget(el);
        if (target) highlight(target);
      }
    }
  }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['data-bmp-size-missing'] });
})();
// BMP-HOOK-END:size-dead-tap
